export default "__VITE_ASSET__XsCEiGVN__"